import styled from 'styled-components';
import { useMemo } from 'react';

import { useDrfqRfq } from '@paradigm/features/src/unified-rfqs/ui/rfq-context';
import {
  paradigmLightBlue,
  pickledBluewood,
} from '@paradigm/design-system/src/colors';
import { useUMPlatformCreationDisabled } from '@paradigm/features/src/platform-state/contexts/providers';
import { useTrackAction } from '@paradigm/features/src/analytics';
import { useHiddenLimitOrderFeatureFlag } from '@paradigm/features/src/feature-flags/context';
import { useContextMenuActions } from '#/components/UnifiedRfqs/context-menu/context-menu';
import { stopPropagation } from './common';

export default function CounterDrfqButton() {
  const isPlatformCreationDisabled = useUMPlatformCreationDisabled();
  const drfq = useDrfqRfq();
  const track = useTrackAction();
  const isHiddenLimitOrderEnabled = useHiddenLimitOrderFeatureFlag();
  const { openDetailsModal } = useContextMenuActions();

  const handleClick = useMemo(() => {
    return stopPropagation(() => {
      if (!drfq?.id) return;
      track('submit hidden limit order');
      openDetailsModal();
    });
  }, [drfq.id, openDetailsModal, track]);

  if (!isHiddenLimitOrderEnabled) {
    return null;
  }

  return (
    <CounterButton
      disabled={isPlatformCreationDisabled}
      onClick={handleClick}
    />
  );
}

const CounterButton = styled.button.attrs({ children: 'Hidden Limit' })`
  width: 84px;
  height: 22px;
  font-size: 12px;
  color: ${paradigmLightBlue};
  background-color: ${pickledBluewood};
  border: 0;
  border-radius: 16px;

  &:disabled {
    opacity: 0.5;
  }
`;
